import {InOut} from 'vue-inout-prop-decorator';
import {Vue} from '@/shared/component';

export abstract class AbstractSearchVue extends Vue {
	@InOut({ type: [ Object, Array ], isVModel: true }) protected value! : Object|Object[];
}
